declare global {
  interface Window {
    dataLayer: unknown[]
    gtag: (...args: unknown[]) => void
  }
}

export const GOOGLE_ADS_ID = 'AW-18410810214'

const SCRIPT_ID = 'gtag-base'

/**
 * Injects the Google tag (gtag.js) for Google Ads conversion tracking.
 * Safe to call more than once — the script is only appended a single time.
 */
export function initGoogleAds(id: string = GOOGLE_ADS_ID): void {
  if (typeof window === 'undefined') return
  if (document.getElementById(SCRIPT_ID)) return

  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', id)
}

/**
 * Reports a Google Ads conversion. Pass the full send_to value from your
 * Google Ads conversion action, e.g. 'AW-18410810214/AbC-D_efGh12345'.
 */
export function trackConversion(sendTo: string, params: Record<string, unknown> = {}): void {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  window.gtag('event', 'conversion', { send_to: sendTo, ...params })
}
